import { ReactNode } from "react";
import Notification from "../NotificationBanner";
import styles from "./index.module.scss";

const LayoutCard = ({
  children,
  header,
  footer,
  error,
}: {
  children: ReactNode | ReactNode[];
  header?: ReactNode | ReactNode[];
  footer?: ReactNode | ReactNode[];
  error?: string;
}) => {
  return (
    <div className={styles.outerContainer}>
      {error && (
        <div className={styles.error}>
          <Notification content={error} error />
        </div>
      )}
      <div className={styles.container}>
        {header && <div className={styles.header}>{header}</div>}
        <div className={styles.content}>{children}</div>
      </div>
      {footer && <div className={styles.footer}>{footer}</div>}
    </div>
  );
};

export default LayoutCard;
